import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-offwhite/95 backdrop-blur-sm border-b border-gold/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <img
              src="https://public.readdy.ai/ai/img_res/9c6f8245-9b62-4527-89bf-39db6d8d45df.png"
              alt="サロンロゴ"
              className="h-10 sm:h-12 w-auto object-contain"
            />
          </div>

          {/* Center: reservation notice */}
          <div className="hidden sm:flex flex-col items-center">
            <span
              className="border border-gold text-gold px-4 py-1 text-xs tracking-widest font-sans-jp"
              style={{ letterSpacing: '0.2em' }}
            >
              完全予約制
            </span>
          </div>

          {/* Right: location */}
          <div className="flex flex-col items-end gap-1">
            <span
              className={`text-xs font-sans-jp tracking-wider transition-colors duration-500 ${
                scrolled ? 'text-salon-gray' : 'text-offwhite/80'
              }`}
            >
              <i className="ri-map-pin-line mr-1" />
              東京都渋谷区
            </span>
            <span
              className="sm:hidden border border-gold text-gold px-3 py-0.5 text-xs tracking-widest font-sans-jp"
              style={{ letterSpacing: '0.15em', fontSize: '10px' }}
            >
              完全予約制
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
